<template>
  <section class="container">
    <div class="news">
      <div class="news__block">
        <!-- 分類導覽 -->
        <aside class="side">
          <el-radio-group
            v-model="CategoryId"
            @change="GetList()"
          >
            <ul class="side__list">
              <li
                v-for="item in NewsCategories"
                :key="item.newsCategoryId"
                class="side__item"
              >
                <el-radio
                  class="side__button"
                  :label="item.newsCategoryId"
                >
                  {{ item.newsCategoryName }}
                </el-radio>
              </li>
            </ul>
          </el-radio-group>

          <el-select
            v-model="CategoryId"
            @change="GetList()"
          >
            <el-option
              v-for="item in NewsCategories"
              :key="item.newsCategoryId"
              :label="item.newsCategoryName"
              :value="item.newsCategoryId"
            />
          </el-select>
        </aside>

        <!-- 主要內容 -->
        <div class="news-main">
          <ul class="news-article">
            <li class="news-article__list">
              <router-link
                v-for="newsItem in PageInfo.data"
                :key="newsItem.newsId"
                :to="{
                  name: 'newsDetail',
                  params: { id: newsItem.newsId, fromIndex: true }
                }"
                class="news-article__item"
              >
                <div class="news-article__date">
                  <p>{{ newsItem.newsStartDate | toTaipei | moment('YYYY.MM.DD') }}</p>
                </div>

                <div class="news-article__tag">
                  <span>{{ newsItem.newsCategoryName }}</span>
                </div>

                <div class="news-article__content">
                  <p>{{ newsItem.newsSubject }}</p>
                </div>
              </router-link>
            </li>
          </ul>

          <div class="pagination pagination--center">
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :current-page.sync="Pagination.pageIndex"
              :page-size="Pagination.pageSize"
              :total="PageInfo.count"
              @current-change="GetList()"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { GetNewsCategoryAll, GetNewsList } from '@/api/NewsApi';

export default {
  data() {
    return {
      Pagination: {
        pageIndex: 1,
        pageSize: 6,
        data: { newsCategoryId: 0 },
      },
      PageInfo: {
        count: 0, // api給的總筆數
        data: [],
      },
      NewsCategories: [],
      CategoryId: 0,
    };
  },
  // 當有設定keep的時候，返回到此頁面會執行這個，不會執行created()，所以這邊就不用放created()
  async activated() {
    if (!this.$route.meta.isBack) {
      // 不是從指定頁面返回的話，進行初始化設定
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 6, // 預設每頁幾筆
        data: { newsCategoryId: 0 },
      };

      this.PageInfo = {
        count: 0, // api給的總筆數
        data: [],
      };
    }
    // 取得選單
    await this.GetNewsCategoryList();
    this.GetList();
  },
  methods: {
    GetNewsCategoryList() {
      return GetNewsCategoryAll().then((response) => {
        if (response.data.statusCode === 0) {
          this.NewsCategories = response.data.data;
          if (this.NewsCategories.length > 0) {
            if (this.CategoryId === 0) {
              this.CategoryId = this.NewsCategories[0].newsCategoryId;
            }
          }
        }
      });
    },
    GetList() {
      if (this.Pagination.data.newsCategoryId !== this.CategoryId) {
        this.Pagination = {
          pageIndex: 1, // 預設從第幾頁開始
          pageSize: 6, // 預設每頁幾筆
          data: { newsCategoryId: 0 },
        };
      }
      this.Pagination.data.newsCategoryId = this.CategoryId;
      GetNewsList(this.Pagination).then((response) => {
        if (response.data.statusCode === 0) {
          this.PageInfo.count = response.data.count;
          this.PageInfo.data = response.data.data;

          if (this.Pagination.pageIndex !== 1 && this.PageInfo.data.length === 0) {
            this.Pagination.pageIndex = 1;
            this.GetList();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  &__block {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  &-main {
    width: calc(100% - 250px);

    @media (max-width: 991px) {
      width: 100%;
      margin-top: 20px;
    }
  }

  &-article {
    &__item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      width: 100%;
      padding: 15px;
      border-radius: 4px;
      background-color: #f7f7f7;
      transition-property: transform;
      transition-duration: .3s;
      transition-timing-function: linear;

      @media (max-width: 767px) {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      &:nth-child(n + 2) {
        margin-top: 12px;
      }

      &:hover {
        transform: translateX(10px);
      }
    }

    &__date {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 82px;
      font-size: 14px;
      font-weight: 500;
      line-height: 1;
      color: #333;

      @media (max-width: 767px) {
        justify-content: flex-end;
        order: 2;
      }
    }

    &__tag {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 128px;
      margin-left: 20px;

      @media (max-width: 767px) {
        margin: 0;
        order: 1;
      }

      span {
        display: inline-block;
        min-width: 128px;
        padding: 4px 8px;
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
        color: #fff;
        background: #aaa;
        border-radius: 2px;
      }
    }

    &__content {
      width: calc(100% - 250px);
      margin-left: 20px;
      font-size: 16px;
      color: #777;

      @media (max-width: 767px) {
        order: 3;
        width: 100%;
        margin: 10px 0 0;
      }
    }
  }
}
</style>
